import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { H3 } from 'components/common/headers';
import StackContainer from 'components/common/containers/stack_container';
import InlineContainer from 'components/common/containers/inline_container';
import { spaceFor } from 'components/space_helper';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

/**
 * @visibleName Form Layout
 */

const FormSection = ({ header, description, children }) => (
  <StyledFormSection>
    {header && <SectionHeader>{header}</SectionHeader>}
    {description && <SectionDescription>{description}</SectionDescription>}
    {children}
  </StyledFormSection>
);
FormSection.propTypes = {
  header: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.any,
};

const FormCol = styled.div``;

const SectionHeader = styled(H3)`
  color: ${p => p.theme.colors.gray700};
`;

export const SectionDescription = styled.p`
  color: ${p => p.theme.colors.gray700};
`;

const FormRow = styled(InlineContainer).attrs({ inset: 'none', inline: 'small', stack: 'medium' })`
  margin-bottom: ${p => (p.stack !== 'end' ? spaceFor('stack', p) : 0)};
`;

const StyledFormSection = styled(StackContainer).attrs({ inset: 'none' })`
  display: flex;
  flex-direction: column;
`;

export { FormCol, FormRow, FormContainer, FormSection };
